(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["xstore-header"]) return;
  try {
    
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') document.querySelectorAll('.xs-header details[open]').forEach(function(el) { el.open = false; });
});
document.addEventListener('click', function(event) {
  document.querySelectorAll('.xs-header details[open]').forEach(function(el) { if (!el.contains(event.target)) el.open = false; });
});

  } catch(e) { console.error(e); }
})();
})();
